






































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
class AutorizeDeviceDto extends PageRequest {
  userId: number;
  deviceId: any[] = [];
}
@Component({
  components: {},
})
export default class AuthorizeDevice extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Array, default: [] }) pressurelist: Array<any>;
  orgdeivetdto: AutorizeDeviceDto = new AutorizeDeviceDto();
  cidlist: Array<any> = [];
  loading: boolean = false;
  list: [] = [];
  create() {}
  created() {
    this.getUsers();
  }
  save() {
    (this.$refs.itemForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        let res = await this.$store
          .dispatch({
            type: "pressure/authorizeDevice",
            data: this.orgdeivetdto,
          })
          .catch((err) => {
            this.loading = false;
            this.$Modal.info({
              title: this.L("Tips"),
              content: err,
            });
          });
        this.$Modal.info({
          title: this.L("Tips"),
          content: res.data.result,
        });
        this.loading = false;
        (this.$refs.itemForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.itemForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      //this.getAuthorizeUser();
      //this.getpage();
      this.$emit("input", value);
    } else {
      this.getpage();
    }
  }
  itemRule = {
    userId: [
      {
        required: true,
        type: "number",
        message: this.L("PleasChoose") + this.L("Users"),
        trigger: "blur",
      },
    ],
  };
  //获取用户
  async getUsers() {
    await this.$store
      .dispatch("user/getallusers")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.$data.optionsMechanism.push({
              label: ele.name + "(" + ele.mobile + ")",
              value: ele.id,
            });
          });
        }
      })
      .catch((err) => {
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
  }
  //获取已授权用户
  async getAuthorizeUser() {
    let res = await this.$store
      .dispatch({
        type: "pressure/pressureAuthorizeUser",
        data: this.orgdeivetdto,
      })
      .catch((err) => {
        this.loading = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
    console.log(res);
  }
  // get list() {
  //   return this.$store.state.customermeter.customerlist;
  // }
  pageChange(page: number) {
    this.$store.commit("customermeter/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("customermeter/setPageSize", pagesize);
    this.getpage();
  }
  changeSort(key) {
    if (key.order !== "normal") {
      this.orgdeivetdto.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  async getpage() {
    this.orgdeivetdto.maxResultCount = this.pageSize;
    this.orgdeivetdto.skipCount = (this.currentPage - 1) * this.pageSize;
    let res = await this.$store
      .dispatch({
        type: "pressure/pressureAuthorizeUser",
        data: this.orgdeivetdto,
      })
      .catch((err) => {
        console.log(err);
      });
    this.list = res.data.result;
  }
  get pageSize() {
    return this.$store.state.customermeter.pageSize;
  }
  get totalCount() {
    return this.$store.state.customermeter.totalCount;
  }
  get currentPage() {
    return this.$store.state.customermeter.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("DeviceNo"),
      key: "deviceNo",
      sortable: true,
      width: 130,
    },
    {
      title: this.L("Location"),
      key: "location",
      width: 130,
    },
    {
      title: this.L("UserName"),
      key: "userName",
      sortable: true,
      width: 130,
    },
    {
      title: this.L("Mobile"),
      key: "mobile",
      width: 130,
    },
  ];
  data() {
    return {
      optionsMechanism: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  @Watch("pressurelist")
  getitemId() {
    this.orgdeivetdto.deviceId = this.pressurelist;
  }
}
